import React from 'react';
import { deleteCustomerActivityNote, editCustomerActivityNote } from '../../../../../../store/thunks/customers/customersViewPageThunks';
import { PermissionEnum } from '../../../../../../core/enums/dictionariesEnums';
import NoteEvent from '../../../../../../common/components/activity-events/note/NoteEvent';
import { BasicNoteEventProps } from '../../../../../../core/types/coreTypes';
import { useNoteActivityLog } from '../../../../../../common/hooks/useNoteActivityLog';

const CustomerNoteEvent: React.FC<BasicNoteEventProps> = ({ id, content = '', initiator = '' }) => {
  const {
    dispatch,
    value,
    setValue,
    isEditModal,
    isConfirmationModal,
    setIsConfirmationModal,
    closeHandle,
    menuItems,
  } = useNoteActivityLog(content);

  const editHandle = () => {
    id && dispatch(editCustomerActivityNote({
      id,
      content: value.trim(),
      closeModal: closeHandle,
    }));
  };

  const deleteHandle = () => {
    id && dispatch(deleteCustomerActivityNote({
      id,
      closeModal: () => setIsConfirmationModal(false),
    }));
  };

  return (
    <NoteEvent
      content={content}
      menuItems={menuItems}
      value={value}
      setValue={setValue}
      isEditModal={isEditModal}
      closeEditModal={closeHandle}
      editHandle={editHandle}
      isConfirmationModal={isConfirmationModal}
      setIsConfirmationModal={setIsConfirmationModal}
      deleteHandle={deleteHandle}
      initiator={initiator}
      permission={PermissionEnum.CustomerEditDeleteNotesOfOtherUsersInActivityLog}
    />
  );
};

export default CustomerNoteEvent;
